import { render, staticRenderFns } from "./iconSecurity.vue?vue&type=template&id=e5e4c0c0"
import script from "./iconSecurity.vue?vue&type=script&lang=js"
export * from "./iconSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports